/**
 * Chrome + density tokens — single source for layout, spacing, and radius policy.
 *
 * Radius policy:
 * - 0 on shells, sidebars, viewport, page panels (PANEL_RADIUS)
 * - 4 on buttons, inputs, chips, small icon targets (CONTROL_RADIUS)
 */

/** Top app bar / editor header */
export const CHROME_HEADER_HEIGHT = 48;

/** Realtime status footer */
export const CHROME_FOOTER_HEIGHT = 22;

/** Left tool rail */
export const CHROME_NAVBAR_WIDTH = 48;

/** Right inspector aside */
export const CHROME_ASIDE_WIDTH = 272;

/** Gap between chrome and 3D canvas (0 = full-bleed) */
export const CANVAS_GUTTER = 0;

/** Viewport frame corner radius */
export const CANVAS_RADIUS = 0;

/** Vertical padding on dashboard / workflow pages */
export const PAGE_PADDING_Y = 20;

/** Gap between major page sections */
export const SECTION_GAP = 24;

/** Shell panels, sidebars, viewport */
export const PANEL_RADIUS = 0;

/** Buttons, inputs, chips, icon targets */
export const CONTROL_RADIUS = 4;

/** Chrome / toolbar text */
export const CHROME_TEXT_SIZE = 13;

/** List rows, secondary labels */
export const LIST_TEXT_SIZE = 12;

/** Icon button hit target */
export const CHROME_ICON_HIT = 30;

/** Subscribe reminder bar under main nav */
export const SUBSCRIBE_BAR_HEIGHT = 44;

/** Inspector tab bar */
export const CHROME_TAB_BAR_HEIGHT = 34;

/** Shared Mantine Container props for dashboard pages */
export const pageLayoutProps = {
  size: "xl",
  px: { base: "md", sm: "lg" },
  py: PAGE_PADDING_Y,
};

/** @deprecated Use pageLayoutProps — kept for existing imports */
export const projectsPageContainerProps = {
  size: pageLayoutProps.size,
  px: pageLayoutProps.px,
};
